@if (initialLoading()) {
  <span class="block-height">
    <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
  </span>
} @else if (!entityId() && !entity()) {
  <span
    matTooltip="no record defined"
    i18n-matTooltip="No record defined tooltip"
    >-</span
  >
} @else if (notFound()) {
  <span
    class="block-height truncate-text inactive"
    matTooltip="This record does not exist anymore or you do not have the required permissions to access it."
    i18n-matTooltip="Entity not found tooltip"
  >
    <app-fa-dynamic-icon
      [icon]="notFoundIcon()"
      class="margin-right-small"
    ></app-fa-dynamic-icon>

    @if (missingEntityType()) {
      {{ missingEntityType()?.label }}:
    }
    <span i18n="Entity block not found message">not available</span>
  </span>
} @else {
  <span
    class="block-height truncate-text"
    [class.clickable]="!linkDisabled()"
    [class.inactive]="!entityResource.value()?.isActive"
    (click)="showDetailsPage()"
    [appTemplateTooltip]="tooltip"
    [tooltipDisabled]="!entityBlockConfig()"
    [title]="entityResource.value()?.toString()"
  >
    <app-fa-dynamic-icon
      [icon]="entityIcon()"
      [style.color]="entityColor()"
      class="margin-right-small"
    ></app-fa-dynamic-icon>

    {{ entityResource.value()?.toString() }}
  </span>
}

<!-- Tooltip on Hover -->
<ng-template #tooltip>
  <div class="tooltip-container">
    @if (entityBlockConfig()?.image) {
      <app-display-img
        class="tooltip-photo"
        [entity]="entityResource.value()"
        [imgProperty]="entityBlockConfig()?.image"
      ></app-display-img>
    }

    <div>
      <!-- Font-weight is applied as style to override the default -->
      <h3 style="font-weight: bold">
        @if (entityBlockConfig()?.title) {
          <app-entity-field-view
            [entity]="entityResource.value()"
            [field]="entityBlockConfig()?.title"
          ></app-entity-field-view>
        } @else {
          {{ entityResource.value()?.toString() }}
        }
      </h3>

      @for (field of entityBlockConfig()?.fields; track field) {
        <app-entity-field-view
          [entity]="entityResource.value()"
          [field]="field"
        ></app-entity-field-view>
      }
    </div>
  </div>
</ng-template>
